import React, { useState } from "react";
import { Button, Dialog, DialogContent, Stack, TextField } from "@mui/material";
import { Title } from "./style";
import { ClipLoader } from "react-spinners";
import { Toast } from "../../components/components/Toast";
import Repo from "../../Repository/Repo";

function CreateLink({ onClose, id, userName, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState(userName ? userName : "");

  const handleInput = (e) => {
    const { value } = e.target;
    setUrl(value);
  };

  const handleSubmit = async () => {
    try {
      if (!url) {
        Toast("info", "Kindly add a name");
        return;
      }
      setLoading(true);

      let { data } = await Repo.store({
        request: {
          method: "insertUserNameById",
          data: {
            _id: id,
            userName: url,
          },
        },
      });
      console.log(data);
      setLoading(false);
      if (data.response.data._id) {
        onSuccess();
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleEnter = (e) => {
    if (e.key == "Enter") {
      handleSubmit();
    }
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px" alignItems="center">
          <Title sx={{ textAlign: "center", fontSize: "18px" }}>
            Create your store link
          </Title>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Store link"
            value={url}
            disabled={loading ? true : false}
            onChange={handleInput}
            onKeyDown={handleEnter}
          />
          {loading && <ClipLoader color="#4eaf51" size={26} loading={true} />}
          {!loading && (
            <Button
              size="small"
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={handleSubmit}
            >
              {userName ? "Update Link" : "Create Link"}
            </Button>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default CreateLink;
